// Action type constants for the Conversation Explorer slice.
// `as const` gives each value a literal string type.
const actions = {
  SET_STATE: 'conversationExplorer/SET_STATE',
  RESET: 'conversationExplorer/RESET',
  LIST_CONVERSATIONS: 'conversationExplorer/LIST_CONVERSATIONS',
  SELECT_CONVERSATION: 'conversationExplorer/SELECT_CONVERSATION',
  // Drops the open conversation without touching the list or its filters —
  // used when the viewer changes, since another user's thread must not linger.
  CLEAR_SELECTION: 'conversationExplorer/CLEAR_SELECTION',
  LIST_MESSAGES: 'conversationExplorer/LIST_MESSAGES',
  // Same worker as LIST_MESSAGES but bound to takeLatest — used for the in-thread
  // search (a replace), so a slow stale response can't overwrite a newer one.
  SEARCH_MESSAGES: 'conversationExplorer/SEARCH_MESSAGES',
  SELECT_MESSAGE: 'conversationExplorer/SELECT_MESSAGE',
  // Right panel — supporting Admin calls (lazy, on accordion open)
  FETCH_GROUP_MEMBERS: 'conversationExplorer/FETCH_GROUP_MEMBERS',
  FETCH_FLAGGED_MESSAGES: 'conversationExplorer/FETCH_FLAGGED_MESSAGES',
  FETCH_MESSAGE_REACTIONS: 'conversationExplorer/FETCH_MESSAGE_REACTIONS',
  FETCH_MESSAGE_RECEIPTS: 'conversationExplorer/FETCH_MESSAGE_RECEIPTS',
  // Deep-link: open a conversation anchored on a specific message (from logs)
  OPEN_AT_MESSAGE: 'conversationExplorer/OPEN_AT_MESSAGE',
  // Center — thread replies of a parent message (GET /messages/{id}/thread)
  FETCH_MESSAGE_THREAD: 'conversationExplorer/FETCH_MESSAGE_THREAD',
  // Left panel — refresh a single row's stale lastMessage (GET /conversations/{id})
  REFRESH_CONVERSATION_ROW: 'conversationExplorer/REFRESH_CONVERSATION_ROW',
} as const

export default actions
